<template>
	<div class="login-bg">
		<div class="bg-color">

			<div class="login-title">
				<div class="siwld" @click="openLanguage">
					<div class="lang-btn-text">
						🌐 {{ langLabel }}
					</div>
				</div>
				<div class="title-name">
					<div class="logo-image">
						<img src="/img/login/logo.png" alt="logo" />
					</div>
				</div>
			</div>

			<div class="form">
				<div class="input">
					<span class="tn-icon-my-reduce"></span>
					<input v-model="username" type="text" :placeholder="$t('common.username')" />
				</div>
				<div class="input">
					<span class="tn-icon-lock"></span>
					<input v-model="password" :type="passwordType" :placeholder="$t('auth.login_password')" />
					<div class="ticon" @click="switchPasswordType">
						<span v-if="passwordType === 'password'" class="tn-icon-eye-hide"></span>
						<span v-else class="tn-icon-eye"></span>
					</div>
				</div>
				<div class="reg">
					<div class="" style="display: flex;">
						<van-checkbox v-model="checked" shape="square" icon-size="17px"></van-checkbox>
						<div class="ze">{{ $t('auth.remember_password') }}</div>
					</div>
					<div class="xg" @click="openServiceLink()">
						{{ $t('auth.forgot_password') }}
					</div>
				</div>
				<div class="butt" @click="doLogin()">
					<span>{{ $t('auth.login') }}</span>
				</div>
				<div class="register-link" @click="toRegister()">
					{{ $t('auth.no_account_register') }}
				</div>
			</div>

			<Language ref="languagePicker" @change="handleLanguageChange" />
		</div>
	</div>
</template>

<script>
	import Language from '@/common/Language.vue';

	export default {
		components: {
			Language,
		},
		model: {
			prop: "inputValue",
			event: "input",
		},
		props: {
			/**
			 * 当前输入的值
			 */
			inputValue: {
				type: String,
				default: "",
			},
		},
		data() {
			return {
				lang: 'de',
				langLabel: 'Deutsch',
				username: "",
				password: this.inputValue,
				passwordType: "password",
				checked: false,
			};
		},
		beforeMount() {
			// 如果没有设置语言，默认设置为德语
			if (!localStorage.getItem("lang")) {
				localStorage.setItem("lang", "de")
			}
		},
		mounted() {
			this.lang = localStorage.getItem("lang") || 'de';
			this.langLabel = this.getLangLabel(this.lang);
		},
		methods: {
			getLangLabel(code) {
				const labelMap = {
					de: 'Deutsch',
					pt: 'Portugues',
					fr: 'Francais',
					ga: 'Gaeilge',
				};
				return labelMap[code] || labelMap.de;
			},
			openLanguage() {
				this.$refs.languagePicker.open();
			},
			handleLanguageChange(payload) {
				this.lang = payload.code;
				this.langLabel = payload.label;
			},
			switchPasswordType() {
				this.passwordType =
					this.passwordType === "password" ? "text" : "password";
			},
			back() {
				return window.history.back();
			},
			toRegister() {
				this.$router.push("Register");
			},
			openServiceLink() {
				const service = this.$store.getters.getBaseInfo || {};
				if (service.iskefu == 1 && service.kefu) {
					window.location.href = service.kefu;
					return;
				}
				this.$toast(this.$t("setting.forbid"));
			},
			doLogin() {
				if (
					this.username === "" ||
					this.username === null ||
					this.username === undefined
				) {
					this.$toast(this.$t("auth.username_place"));
					return false;
				}
				if (
					this.password === "" ||
					this.password === null ||
					this.password === undefined
				) {
					this.$toast(this.$t("auth.pwd_place"));
					return false;
				}
				this.$http({
					url: "member_login",
					method: "get",
					data: {
						username: this.username,
						password: this.password,
						// lang: this.lang
					},
				}).then((res) => {
					if (res.code === 200) {
						this.$toast.success(res.msg);
						localStorage.setItem("token", res.data.id);
						this.$router.push("Mine");
					} else {
						this.$toast(res.msg);
					}
				});
			},
		},
		created() {
			if (localStorage.getItem("token")) {
				return window.history.back();
			}
		},
	};
</script>

<style lang='less' scoped>
	.login-bg {
		background-image: url(/img/login/login-bg.png);
		background-size: 100% 100%;
		position: relative;
		width: 100%;
		height: 100vh;
	}

	.login-bg .bg-color {
		background: linear-gradient(180deg, #000, #600);
		width: 100%;
		height: 100vh;
	}

	.login-bg .login-title {
		padding: 15px;
	}

	.login-bg .login-title .siwld {
		position: fixed;
		top: 20px;
		right: 15px;
		z-index: 999;
		display: inline-flex;
		align-items: center;
		padding: 5px 10px;
		background: hsla(0, 0%, 100%, .15);
		border-radius: 15px;
	}

	.login-bg .login-title .siwld .lang-btn-text {
		font-size: 13px;
		color: #fff;
		white-space: nowrap;
	}

	.login-bg .login-title .title-name {
		margin-right: auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.login-bg .login-title .logo-image {
		margin-top: 80px;
		width: 260px;
		height: 72px;
		margin-bottom: 60px;
	}

	.login-bg .login-title .logo-image img {
		width: 100%;
		height: 100%;
	}

	.form {
		margin: 10px;
		padding: 10px;
		height: 364px;
		border-radius: 10px;
	}

	.form .input {
		padding: 10px 20px;
		background-color: #fff;
		border-radius: 26px;
		margin-bottom: 31px;
		margin-right: auto;
		display: flex;
	}

	.form .input input {
		font-size: 16px;
		color: #4b4b4b;

		display: block;
		line-height: 1.4em;
		height: 1.4em;
		min-height: 1.4em;
		overflow: hidden;

		text-align: left;
		border: none;
		outline: none;
		z-index: 2;
		background-color: #fff;
	}

	.form .input input::placeholder {
		font-size: 16px;
	}

	.form .input .tn-icon-my-reduce,
	.form .input .tn-icon-lock {
		display: -webkit-flex;
		display: flex;
		align-self: center;
		font-size: 20px;
		margin-right: 5px;
	}

	.form .input .ticon {
		color: #4b4b4b;
		display: flex;
		align-items: center;
		font-size: 21px;
		margin-left: auto;
	}

	.login-bg .reg {
		margin: 0px;
		padding: 0px 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.login-bg .reg .ze {
		color: #fff;
		font-size: 14px;
		margin-left: 17px;
	}

	.login-bg .reg .xg {
		color: #fff;
		font-size: 14px;
	}

	.login-bg .butt {
		margin: 10px;
		border-radius: 52px;
		padding: 10px;
		margin-top: 15px;
		margin-bottom: 31px;
		background-image: repeating-linear-gradient(45deg, red, #c00) !important;
	}

	.login-bg .butt span {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 18px;
	}

	.register-link {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff !important;
		font-size: 14px;
	}

	::v-deep .van-icon {
		border-radius: 3px;
	}
</style>
